module.exports = __webpack_public_path__ + "e5f75d80.png";